import React from 'react'

import { twMerge } from 'tailwind-merge'

interface ShiftEnterMessage {
  show: boolean
  className?: string
}

const ShiftEnterMessage: React.FC<ShiftEnterMessage> = ({
  show,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'flex items-center w-full justify-end text-[11px] text-primary-500 dark:text-primary-400 transition-opacity duration-100',
        show ? 'opacity-100' : 'opacity-0',
        className,
      )}
    >
      <span>
        <span className="font-medium text-primary-600 dark:text-primary-300">
          Shift + Return
        </span>{' '}
        to enter a new line
      </span>
    </div>
  )
}

ShiftEnterMessage.displayName = 'RichTextArea.ShiftEnterMessage'

export { ShiftEnterMessage }
